import React, { useState, useEffect } from "react";
import notification from "../assets/images/global_icons/Notification.svg";
// import classes from "../assets/styles/Navbar.module.css";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import dummyimage from "../assets/images/global_icons/dummyimage.svg";
import { FiSettings } from "react-icons/fi";
import { BiHelpCircle } from "react-icons/bi";
import { IoIosLogOut } from "react-icons/io";
import { BsPerson } from "react-icons/bs";
import { BiGroup } from "react-icons/bi";
import {
  loggedInUser,
  teamIDCheck,
  accountType,
  subscribedPackage,
} from "../utils/store";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import baseUrl from "../utils/constants/baseUrl";
import AllNotifications from "./AllNotifications";
import showToast from "../helpers/showToast";
import useLogout from "../hooks/useLogout";
import CreateTeamModal from "./Modals/CreateTeamModal";
import {
  CHATBOT,
  CREATE_USER_TEAM_OWNER_ACCOUNT,
  GET_USER,
} from "../utils/constants/apiUrl";
import { post, get } from "../server";
import useFunctionsCount from "../hooks/useFunctionsCount";
import { IoIosArrowDown } from "react-icons/io";
import { trackEvent } from "../utils/mixpanel";
import { Button } from "react-bootstrap";
import LightDarkToggle from "./LightDarkToggle";
import { IoMdSend } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import InfiniteScroll from "react-infinite-scroll-component";

const Navbar = ({ handleShowSidebar }) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [showNotification, setShowNotification] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamOwner, setTeamOwner] = useState({
    team_name: "",
  });
  const { userActions } = useFunctionsCount();

  const handleCloseModal = () => {
    setTeamOwner({ team_name: "" });
    setShowModal(false);
  };
  const [chatHistory, setChatHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [message, setMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const [selectedTheme, setSelectedTheme] = useState("light");
  const [useCustomColor, setUseCustomColor] = useState(false);
  const [themeColor, setThemeColor] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  // other states...
  // useEffect(() => {
  //   const root = document.documentElement;

  //   if (!useCustomColor) {
  //     let newThemeColor = "";
  //     let newButtonColor = "";

  //     if (selectedTheme === "dark") {
  //       newThemeColor = "#222222";
  //       newButtonColor = "#22a081";
  //     } else if (selectedTheme === "light") {
  //       newThemeColor = "#fafafa";
  //       newButtonColor = "#09A0FF";
  //     }

  //     setThemeColor(newThemeColor);
  //     setButtonColor(newButtonColor);

  //     // Now apply CSS variables immediately
  //     if (newThemeColor)
  //       root.style.setProperty("--primary-color", newThemeColor);
  //     if (newButtonColor)
  //       root.style.setProperty("--primary-button-color", newButtonColor);

  //     // Apply body and text colors
  //     if (selectedTheme === "dark") {
  //       root.style.setProperty("--body-color", "#1e1e1e");
  //       root.style.setProperty("--primary-text-color", "#e0e0e0");
  //       root.style.setProperty("--gray-color", "#111111");
  //       root.style.setProperty("--color-white", "#FFFFFF");
  //       root.style.setProperty("--color-black", "#FFFFFF");
  //       root.style.setProperty("--table-color", "#222222");
  //       root.style.setProperty("--table-text", "#FFFFFF");
  //       root.style.setProperty("--sidebar-color", "#111111");
  //       root.style.setProperty("--nav-color", "#111111");
  //       root.style.setProperty("--priority-button-color", "#FFFFFF");
  //       root.style.setProperty("--priority-button-color-text", "#000000");
  //     } else if (selectedTheme === "light") {
  //       root.style.setProperty("--body-color", "#fafafa");
  //       root.style.setProperty("--primary-text-color", "#222222");
  //       root.style.setProperty("--gray-color", "#FFFFFF");
  //       root.style.setProperty("--color-white", "#000000");
  //       root.style.setProperty("--color-black", "#000000");
  //       root.style.setProperty("--table-color", "#FFFFFF");
  //       root.style.setProperty("--table-text", "#222222");
  //       root.style.setProperty("--nav-color", "#FFFFFF");
  //       root.style.setProperty("--priority-button-color", "#FFFFFF");
  //       root.style.setProperty("--priority-button-color-text", "#000000");
  //     }
  //   }
  // }, [selectedTheme, useCustomColor]);

  const handleSaveShowModal = async (newData) => {
    setModalLoading(true);
    let { status, message } = await post(
      CREATE_USER_TEAM_OWNER_ACCOUNT,
      newData,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      let { status, message, data } = await get(
        GET_USER,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        if (Object.keys(data).length > 0) {
          data.token = loggedUser.token;
          setLoggedUser(data);
          userActions(data);
          showToast(
            true,
            "Your team owner account has been created successfully. You can switch to team owner mode by using tab button given in side menu."
          );
        }
      } else {
        showToast(status, message);
      }
    } else {
      showToast(status, message);
    }
    handleCloseModal();
    setModalLoading(false);
  };

  const logout = useLogout();

  const withTeamIdData = loggedUser?.secret_code?.filter(
    (item) => item.team_id !== null
  );

  const handleSwitchAccount = () => {
    if (personalAccount) {
      const isSuspended = loggedUser?.team_members?.some(
        (member) => member.check_status === "suspended"
      );
      if (isSuspended) {
        showToast(
          false,
          "Your account has been suspended by admin, please contact support for further queries"
        );
      } else {
        let teamID = withTeamIdData[0]?.team_id;
        let isTeamPackage = loggedUser?.package_details.filter(
          (obj) => obj.team_id == teamID
        );

        const isExpired = isTeamPackage[0]?.end_date && new Date() >= new Date(isTeamPackage[0].end_date);
        if (isTeamPackage.length <= 0 || isExpired) {
          return showToast(
            false,
            "You can not switch to team mode because your team is not subscribed to any package"
          );
        }
        let teamPackage = loggedUser?.package_details?.find(
          (obj) => obj.team_id == teamID
        );
        setPurchasedPackage(teamPackage?.package || teamPackage);
        setUserTeamId(withTeamIdData[0]?.team_id);
        setPersonalAccount(false);
        navigate("/");
      }
    } else {
      let teamPackage = loggedUser?.package_details?.find(
        (obj) => obj.team_id == null
      );

      setPurchasedPackage(teamPackage?.package || teamPackage);
      setUserTeamId(null);
      setPersonalAccount(true);
      navigate("/team");
    }
  };

  // const checkCustomer = loggedUser?.role?.includes("customer");
  const checkCustomer =
    !loggedUser?.role?.some(
      (role) => role === "customer" || role === "team_owner"
    ) === false;

  const checkTeam = loggedUser?.secret_code?.some(
    (item) => item.team_id !== null
  );
  const isNonOwnerTeamMember =
    (loggedUser?.connected_teams?.length ?? 0) > 0 &&
    !loggedUser?.role?.includes("team_owner");

  const navigate = useNavigate();

  const handleLogout = () => {
    trackEvent("Logout Successfully", {
      timestamp: new Date().toISOString(),
      source: "Navbar Menu",
    });
    logout();
  };

  const handleNotificationClick = (e) => {
    e.stopPropagation();
    setShowNotification(!showNotification);
  };

  // const loadChatHistory = async (pageNumber = 1, scrollTopBefore = 0) => {
  //   if (isFetchingRef.current || !hasMore) return;

  //   isFetchingRef.current = true;

  //   const token = loggedUser?.token || null;
  //   const { status, data } = await get(
  //     `${CHATBOT}?limit=10&page=${pageNumber}`,
  //     token
  //   );

  //   if (status) {
  //     if (data.length === 0) {
  //       setHasMore(false);
  //     } else {
  //       setChatHistory((prev) => [...data, ...prev]);
  //       setPage((prevPage) => prevPage + 1);

  //       // maintain scroll position after prepend
  //       if (chatBodyRef.current) {
  //         requestAnimationFrame(() => {
  //           chatBodyRef.current.scrollTop =
  //             chatBodyRef.current.scrollHeight - scrollTopBefore;
  //         });
  //       }
  //     }
  //   }

  //   isFetchingRef.current = false;
  // };
  const loadChatHistory = async () => {
    if (!hasMore) return;

    const token = loggedUser?.token || null;
    const { status, data } = await get(
      `${CHATBOT}?limit=10&page=${page}`,
      token
    );

    if (status && data.length > 0) {
      setChatHistory((prev) => [...data, ...prev]); // prepend
      setPage((prev) => prev + 1);
    } else {
      setHasMore(false);
    }
  };

  useEffect(() => {
    if (
      loggedUser?.role?.includes("customer") ||
      loggedUser?.role?.includes("team_owner")
    ) {
      setPage(1);
      setHasMore(true);
      setChatHistory([]);
      loadChatHistory();
    }
  }, [loggedUser]);

  const sendMessage = async () => {
    if (!message.trim()) return;

    const userMsg = {
      type: "user",
      message,
      created_at: new Date().toISOString(),
      user: {
        first_name: loggedUser?.first_name,
        last_name: loggedUser?.last_name,
      },
    };

    // Optimistically add user message
    setChatHistory((prev) => [...prev, userMsg]);
    setMessage("");
    setIsTyping(true);

    try {
      const payload = { message }; // Adjust key if backend expects different
      const { status, data, response } = await post(
        CHATBOT,
        payload,
        loggedUser?.token
      );

      if (status) {
        console.log("Chatbot response:", response);
        const botMsg = {
          type: "chatbot",
          message: response,
          created_at: new Date().toISOString(),
          user: {
            first_name: "AI",
            last_name: "Agent",
          },
        };

        setChatHistory((prev) => [...prev, botMsg]);
      }
    } catch (err) {
      console.error("Failed to send message", err);
      // You can optionally show error message here
    } finally {
      setIsTyping(false); // Hide typing indicator
    }
  };

  return (
    <>
      <section className="navbar">
        <div className="container-fluid">
          <ul className="navItemsWrapper list-unstyled">
            {/* <li className="menuIconBtnListItem">
              <button className="navIconBtns" onClick={handleShowSidebar}>
                <BiMenu />
              </button>
            </li> */}
            {/* <li>
              <LightDarkToggle
                selectedTheme={selectedTheme}
                setSelectedTheme={setSelectedTheme}
              />
            </li> */}

            {!checkTeam && loggedUser?.role?.includes("customer") && (
              <li>
                <Button
                  variant="link"
                  className="createTeamBtn"
                  onClick={() => setShowModal(true)}
                >
                  Create Team
                </Button>
              </li>
            )}

            {/* {!loggedUser?.role?.includes("super_admin") && (
              <li>
                <Button
                  variant="primary"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                  className="navIconBtns me-4 rounded-circle px-2 py-1"
                >
                  <BiSupport />
                </Button>
              </li>
            )} */}
            {checkCustomer && (
              <li>
                <Button
                  variant="link"
                  className="navIconBtns p-0 me-4"
                  onClick={handleNotificationClick}
                >
                  <img src={notification} alt="Notification Icon" />
                </Button>
                {showNotification && (
                  <AllNotifications
                    showNotification={showNotification}
                    setShowNotification={setShowNotification}
                  />
                )}
              </li>
            )}
            <li>
              <div className="dropdown">
                <Button
                  variant="link"
                  type="button"
                  className="dropdown-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <Image
                    src={baseUrl.PUBLIC_URL + loggedUser.profile_image}
                    width="30px"
                    height="30px"
                    loading="lazy"
                    decoding="async"
                    roundedCircle={true}
                    className="imageBackground me-2"
                    onError={(e) => {
                      e.currentTarget.src = dummyimage;
                    }}
                  />
                  {/* <img
                            src={arrow}
                            alt="Arrow icon"
                            className={classes.arrowIcon}
                          /> */}
                  <span className="arrowIcon">
                    <IoIosArrowDown />
                  </span>
                </Button>
                <ul
                  className="customActionDropdownMenu dropdown-menu"
                  style={{ minWidth: "260px" }}
                >
                  <div className="profileWrapper d-flex align-items-center">
                    <Image
                      src={baseUrl.PUBLIC_URL + loggedUser.profile_image}
                      width="32px"
                      loading="lazy"
                      decoding="async"
                      height="32px"
                      roundedCircle={true}
                      className="imageBackground me-3"
                      onError={(e) => {
                        e.currentTarget.src = dummyimage;
                      }}
                    />
                    <div>
                      <h6>
                        {`${loggedUser?.first_name || ""} ${
                          loggedUser?.last_name || ""
                        }
                             `}
                      </h6>
                      <p>{loggedUser?.email || ""}</p>
                    </div>
                  </div>
                  {checkCustomer && (
                    <>
                      <li>
                        <Link className="dropdown-item" to="/settings">
                          <p className="d-flex align-items-center justify-content-between w-100">
                            <span>My Profile</span>
                            {checkCustomer &&
                              !userTeamId &&
                              !isNonOwnerTeamMember && (
                              <div className="package-tag">
                                <Link to="/packages">
                                  {purchasedPackage?.package_name}
                                </Link>
                              </div>
                            )}
                          </p>
                        </Link>
                      </li>
                      {/* <li>
                        <Link className="dropdown-item" to="/help">
                          <div className="iconsWrapper">
                            <div>
                              <BiHelpCircle />
                            </div>
                            <p>Help</p>
                          </div>
                        </Link>
                      </li> */}
                      {loggedUser?.secret_code?.length === 2 &&
                        (loggedUser?.connected_teams?.length ?? 0) === 0 && (
                          <li onClick={handleSwitchAccount}>
                            <span className="dropdown-item">
                              <div className="iconsWrapper">
                                <div>
                                  {personalAccount ? <BiGroup /> : <BsPerson />}
                                </div>
                                <p>
                                  Switch to
                                  {personalAccount ? " Team" : " Personal"}
                                </p>
                              </div>
                            </span>
                          </li>
                        )}
                    </>
                  )}
                  <li onClick={() => handleLogout()}>
                    <span className="dropdown-item">Log out</span>
                  </li>
                </ul>
              </div>
            </li>

            {/* <li>
                  <div className={classes.profileWrapper}>
                    <div className="dropdown">
                      <button
                        className={`btn custom-dropdown-toggle dropdown- ${classes.dropdownBtn}`}
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img src={notification} alt="Notification Icon" />
                      </button>
                      <ul className="customActionDropdownMenu dropdown-menu">
                        <li>Here are data</li>
                      </ul>
                    </div>
                  </div>
                </li> */}
          </ul>
        </div>
      </section>
      {showModal && (
        <CreateTeamModal
          show={showModal}
          data={teamOwner}
          setSelectedData={setTeamOwner}
          handleCloseModal={handleCloseModal}
          handleSaveShowModal={handleSaveShowModal}
          loading={modalLoading}
        />
      )}
      <div
        class="offcanvas offcanvas-end chat-sidebar"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel">
            Conversation with AI Agent
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <InfiniteScroll
            dataLength={chatHistory.length}
            next={loadChatHistory}
            inverse={true}
            hasMore={hasMore}
            // loader={
            //   <div className="loading-container align-center">
            //     <p>Loading older messages...</p>
            //   </div>
            // }
            endMessage={
              chatHistory.length > 0 && hasMore === false ? (
                <p className="mb-20" style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              ) : null
            }
          >
            <div className="chat-body">
              {chatHistory.map((chat, index) => (
                <React.Fragment key={index}>
                  {index === 0 ||
                  new Date(chat.created_at).toDateString() !==
                    new Date(
                      chatHistory[index - 1].created_at
                    ).toDateString() ? (
                    <div className="chat-date">
                      <span>
                        {new Date(chat.created_at).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })}
                      </span>
                    </div>
                  ) : null}

                  <div
                    className={`chat-message ${
                      chat.type === "user" ? "user" : "agent"
                    }`}
                  >
                    <p>{chat.message}</p>
                    <span className="timestamp">
                      {chat.type === "user"
                        ? `${chat?.user?.first_name} ${
                            chat?.user?.last_name
                          } | ${" "}`
                        : "AI Agent | "}
                      {new Date(chat.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                </React.Fragment>
              ))}
              {isTyping && (
                <div className="chat-message agent">
                  <p>
                    <em>Typing...</em>
                  </p>
                </div>
              )}
            </div>
          </InfiniteScroll>
        </div>
        <div className="offcanvas-footer chat-footer">
          <div className="input-group">
            <input
              type="text"
              className="form-control chat-input"
              placeholder="Want to ask something..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button
              className="btn btn-outline-secondary chat-send"
              type="button"
              onClick={sendMessage}
            >
              <IoMdSend />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
